import React from 'react';
export function Footer() {
  const tickerItems = ['NGN/USD: ₦1,520.45', 'Ghana Cedi: GHS 15.82', 'Nigeria GDP Growth: 3.46%', 'Ghana Inflation: 23.1%', 'AfCFTA Trade Volume: +12.4% YoY'];
  // Duplicate items to create a seamless loop
  const allTickerItems = [...tickerItems, ...tickerItems, ...tickerItems];
  return <footer className="bg-navy-deep text-white relative" data-id="element-19">
      {/* Market Pulse Ticker */}
      <div className="w-full bg-navy py-3 border-b border-white/10 overflow-hidden flex whitespace-nowrap" data-id="element-20">
        <div className="flex ticker-animate" data-id="element-21">
          {allTickerItems.map((item, index) => <div key={index} className="flex items-center mx-6" data-id="element-22">
              <span className="font-sans text-sm font-semibold tracking-wide text-white/90" data-id="element-23">
                {item}
              </span>
              <span className="mx-6 text-gold text-lg leading-none" data-id="element-24">•</span>
            </div>)}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-8" data-id="element-25">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16" data-id="element-26">
          {/* Column 1 */}
          <div data-id="element-27">
            <h3 className="font-serif text-gold text-xl font-semibold mb-6" data-id="element-28">
              D.C. Office
            </h3>
            <address className="not-italic font-sans text-sm text-white/70 leading-relaxed space-y-2" data-id="element-29">
              <p data-id="element-30">1001 Pennsylvania Ave NW</p>
              <p data-id="element-31">Suite 800 South</p>
              <p data-id="element-32">Washington, DC 20004</p>
              <p className="pt-4" data-id="element-33">T: +1 (202) 555-0198</p>
              <p data-id="element-34">E: advisory@emmakayconsulting.com</p>
            </address>
          </div>

          {/* Column 2 */}
          <div data-id="element-35">
            <h3 className="font-serif text-gold text-xl font-semibold mb-6" data-id="element-36">
              Lagos & Accra Operations
            </h3>
            <div className="font-sans text-sm text-white/70 leading-relaxed space-y-4" data-id="element-37">
              <p data-id="element-38">
                Maintaining active operational presence and strategic logistics
                hubs in Victoria Island, Lagos and Cantonments, Accra to serve
                our regional clients.
              </p>
              <p data-id="element-39">
                <span className="block text-white font-semibold mb-1" data-id="element-40">
                  Regional Inquiries:
                </span>
                T: +234 (0) 1 454 0000
                <br data-id="element-41" />
                E: westafrica@emmakayconsulting.com
              </p>
            </div>
          </div>

          {/* Column 3 */}
          <div data-id="element-42">
            <h3 className="font-serif text-gold text-xl font-semibold mb-6" data-id="element-43">
              Strategic Partners
            </h3>
            <ul className="font-sans text-sm text-white/70 leading-relaxed space-y-3" data-id="element-44">
              <li className="hover:text-gold cursor-pointer transition-colors" data-id="element-45">
                Legal & Regulatory Counsel
              </li>
              <li className="hover:text-gold cursor-pointer transition-colors" data-id="element-46">
                Risk Advisory Firms
              </li>
              <li className="hover:text-gold cursor-pointer transition-colors" data-id="element-47">
                Local Implementation Partners
              </li>
              <li className="hover:text-gold cursor-pointer transition-colors" data-id="element-48">
                Data Collection Agencies
              </li>
              <li className="hover:text-gold cursor-pointer transition-colors" data-id="element-49">
                Media & Communications Networks
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0" data-id="element-50">
          <div className="font-sans text-xs text-white/50" data-id="element-51">
            © 2026 Emma Kay Consulting. All rights reserved.
          </div>

          <div className="flex-shrink-0 flex flex-col items-center justify-center opacity-50" data-id="element-52">
            <span className="font-serif text-lg font-bold text-white tracking-tight" data-id="element-53">
              EK
            </span>
          </div>

          <div className="font-sans text-xs text-white/50 space-x-4" data-id="element-54">
            <a href="#" className="hover:text-white transition-colors" data-id="element-55">
              Privacy Policy
            </a>
            <span data-id="element-56">•</span>
            <a href="#" className="hover:text-white transition-colors" data-id="element-57">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}